import type { IDBFile } from "~~/types/index-db";

export function useFilesDB() {
  const dbPromise = getIndexDbPromise();

  async function saveFiles(files: IDBFile) {
    const db = await dbPromise;
    await db.put("files", files);
  }

  async function getFiles(): Promise<IDBFile[]> {
    const db = await dbPromise;
    return db.getAll("files");
  }

  async function deleteFiles(submissionId: number): Promise<void> {
    const db = await dbPromise;
    await db.delete("files", submissionId);
  }

  async function deleteAllFiles(submissionId: number): Promise<void> {
    const db = await dbPromise;
    await db.delete("files", submissionId);
  }

  return {
    saveFiles,
    getFiles,
    deleteFiles,
    deleteAllFiles,
  };
}
